define('modules/private/authInfo',['require','exports','module','env'],function (require, exports, module) {
  "use strict";
  var Config = require("env");

  var AuthInfo = function (model) {
    this.model = model;
    this.companyId = this.model.getCompanyId();
    this.companyName = null;
    this.setCompanyData(this.companyId);
  };

  AuthInfo.prototype.getUserName = function () {
    return this.model.getName();
  };

  AuthInfo.prototype.getRolId = function () {
    return this.model.getRole();
  };

  AuthInfo.prototype.getGroupId = function () {
    return this.model.getGroup();
  };

  AuthInfo.prototype.getCompanyId = function () {
    return this.companyId;
  };

  AuthInfo.prototype.setCompanyData = function (companyId) {
    var found = _.find(this.model.getGroupCompanies(), function (cmp) {
      return cmp.id === companyId || !companyId;
    });
    if (found !== undefined) {
      Config.setCompanyId(found.id);
      this.companyId = found.id;
      this.companyName = found.name;
    }
  };

  AuthInfo.prototype.getCompanyName = function () {
    return this.companyName;
  };

  AuthInfo.prototype.getCompanies = function () {
    return [];
  };

  AuthInfo.prototype.getGroupCompanies = function () {
    return this.model.getGroupCompanies();
  };

  module.exports = AuthInfo;
});

